// "지금 실행" 확인 다이얼로그 - window.confirm 대신 MUI Dialog를 쓴다(요구사항).
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

const SysJobRunConfirmDialog = ({ open, job, submitting, onClose, onConfirm }) => (
  <Dialog open={open} onClose={submitting ? undefined : onClose} maxWidth="xs" fullWidth>
    <DialogTitle>지금 실행하시겠습니까?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {job ? `"${job.jobNm}" 작업을 지금 바로 실행합니다. 이미 실행 중이면 요청이 거부됩니다.` : ''}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={submitting}>취소</Button>
      <Button onClick={onConfirm} variant="contained" disabled={submitting} autoFocus>
        실행
      </Button>
    </DialogActions>
  </Dialog>
);

export default SysJobRunConfirmDialog;
